import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Space,
  Tabs,
} from "antd";
import IntlMessage from "../../components/IntlMessage";
import dayjs from "dayjs";
import rateApi from "../../api/rates";
import { useIntl } from "react-intl";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const UpdateRateForm = (props) => {
  const { open, onClose, currentData, onReload } = props;
  console.log("currentData: ", currentData);
  const intl = useIntl();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  let initialValues = {
    adult_price:
      currentData && currentData.adult_price ? currentData.adult_price : null,
    status: currentData && currentData.status ? 1 : 0,
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        console.log("data;", data);
        if (currentData) {
          rateApi
            .update(currentData.id, data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: "global.close" }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const handleDeleteRate = async () => {
    await rateApi
      .delete(currentData?.id)
      .then(() => {
        message.success("Deleted success!");
        onReload();
        onClose();
      })
      .catch((error) => console.log(error));
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const handleCancel = () => {
    onClose();
  };

  const tabItems = [
    {
      key: "1",
      label: <IntlMessage id="global.tour_rates" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.adult_price" />}
            name="adult_price"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item name="status" label={<IntlMessage id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Popconfirm
            title="Delete the rate"
            description="Are you sure to delete this rate?"
            onConfirm={handleDeleteRate}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" danger>
              <IntlMessage id="global.delete" />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.update" />}
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="60%"
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessage id="global.cancel" />}
          </Button>,
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}
          >
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Form
            {...layout}
            form={form}
            labelAlign="left"
            initialValues={initialValues}
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
          >
            <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
          </Form>
        </Space>
      </Modal>
    </React.Fragment>
  );
};

export default UpdateRateForm;
